<template>
    <el-dialog :title="infotableName+' 详情'" v-if="dialogFormVisible" :visible.sync="dialogFormVisible" :append-to-body="true" width="80%" top="5vh">
        <data-info :infotableName="infotableName" :datainfo="datainfo"></data-info>
        <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="结构说明" name="first">
                
            </el-tab-pane>
             <el-tab-pane label="数据详情" name="second">
                <info-data v-if="activeName == 'second'" :tableName="tableName"></info-data>
            </el-tab-pane>
        </el-tabs> -->
    </el-dialog>
</template>

<script>
import DataInfo from './dataInfo'
export default {
    props: {
        infotableName: {
            type: String,
            default: ''
        },
        datainfo:{
            type: Object,
            default:{}
        }
    },

    components: {DataInfo},

    data() {
        return {
            dialogFormVisible:false,
            activeName: 'first'
        }
    },

    methods: {
        // 初始化数据
        init() {
            this.dialogFormVisible = true,
            this.activeName = 'first'
        },

        // 切换tab选项卡
        handleClick(val) {
            console.log(val)

            console.log(this.activeName)
        }
    }
}
</script>